export default __webpack_public_path__ + "static/media/app-example.d65ad655.png";